import AssistantIcon from './AssistantIcon.vue';

export default AssistantIcon;
